import { useCallback } from 'react';

export function useLogger() {
  const logError = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.error(`[WX Error]: ${message}`, ...optionalParams);
    },
    [],
  );

  const logWarn = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.warn(`[WX Warning]: ${message}`, ...optionalParams);
    },
    [],
  );

  const logInfo = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.info(`[WX Info]: ${message}`, ...optionalParams);
    },
    [],
  );

  return {
    logError,
    logWarn,
    logInfo,
  };
}
